export const environment = {
  production: false,
  apiBase: 'https://auth-dev.plandag.com/api',
  coreAppUrl: 'https://dev.plandag.com',
  coreApiUrl: 'https://core-dev.plandag.com/api',
};
